import { USPSAutoManifestScheduleSourceTypeEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';

export class USPSAutoManifestScheduleService {
	private baseUrl = environment.apiGateway.apiUrl;
	private apiUrl = '';

	constructor() {
		this.apiUrl = this.baseUrl + 'manifest/';
	}

    /**
     * upsert USPS Auto Manifest Schedule
    */

    public async UpsertUSPSAutoManifestSchedule(autoManifestScheduleTimeVM: models.IUpsertUSPSAutoManifestScheduleVM, cancelToken?: CancelToken): Promise<models.IUpsertUSPSAutoManifestScheduleVM> {
		try {
            const url = this.apiUrl + 'USPSAutoManifestSchedule';
			const res = await axios.put<models.IUpsertUSPSAutoManifestScheduleVM>(url, autoManifestScheduleTimeVM, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

    /**
	 *  Get USPS Auto Manifest Schedule
	 */
	public async getUSPSAutoManifestSchedule(
		sourceType: USPSAutoManifestScheduleSourceTypeEnum,
		sourceId: string,
		cancelToken?: CancelToken
	): Promise<models.IGetUSPSAutoManifestScheduleResponseVM[]> {
		try {
			const url = this.apiUrl + 'USPSAutoManifestSchedule';
			const res = await axios.get<models.IGetUSPSAutoManifestScheduleResponseVM[]>(url, {
				cancelToken,
				params: {
					sourceType,
					sourceId
				},
			});
			return res.data;
		} catch (error : any) {
			throw error;
		}
	}

}



// WEBPACK FOOTER //
// ./src/services/usps-auto-manifest-schedule.service.ts